var _defs, _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatareliability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.65 21.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f363f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.39,422a2.79,2.79,0,0,1-1.37-.37,2.72,2.72,0,0,1-1-3.77l9.57-15.77h0a2.8,2.8,0,0,1,4.77,0l9.56,15.77a2.73,2.73,0,0,1-.42,3.3,3,3,0,0,1-2,.84Zm8.07-19.36-9.54,15.77a1.63,1.63,0,0,0-.18,1.28,1.68,1.68,0,0,0,.81,1.05,1.6,1.6,0,0,0,.84.24h19.1a1.6,1.6,0,0,0,1.2-.53,1.67,1.67,0,0,0,.27-2l-9.52-15.77a1.73,1.73,0,0,0-2.41-.55,1.87,1.87,0,0,0-.57.55Z",
    transform: "translate(-331.62 -400.73)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344,414.14a.52.52,0,0,1-.52-.52v-6.73a.52.52,0,1,1,1,0v6.73A.52.52,0,0,1,344,414.14Z",
    transform: "translate(-331.62 -400.73)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.33,
    cy: 16.24,
    r: 1.18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.39,422a2.79,2.79,0,0,1-1.37-.37,2.72,2.72,0,0,1-1-3.77l9.57-15.77h0a2.8,2.8,0,0,1,4.77,0l9.56,15.77a2.73,2.73,0,0,1-.42,3.3,3,3,0,0,1-2,.84Zm8.07-19.36-9.54,15.77a1.63,1.63,0,0,0-.18,1.28,1.68,1.68,0,0,0,.81,1.05,1.6,1.6,0,0,0,.84.24h19.1a1.6,1.6,0,0,0,1.2-.53,1.67,1.67,0,0,0,.27-2l-9.52-15.77a1.73,1.73,0,0,0-2.41-.55,1.87,1.87,0,0,0-.57.55Z",
    transform: "translate(-331.62 -400.73)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344,414.14a.52.52,0,0,1-.52-.52v-6.73a.52.52,0,1,1,1,0v6.73A.52.52,0,0,1,344,414.14Z",
    transform: "translate(-331.62 -400.73)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatareliability);
export default __webpack_public_path__ + "static/media/datareliability.812a0f7c5a4bcbb17d8d169447f7d6a6.svg";
export { ForwardRef as ReactComponent };